import * as s from "./s.module.scss"


const useTextColor = textColor => {
  return {
    [s.red]: textColor === "red",
    [s.black]: textColor === "black",
    [s.yellow]: textColor === "yellow",
    [s.pink]: textColor === "pink",
    [s.green]: textColor === "green",
    [s.neongreen]: textColor === "neongreen",
    [s.purple]: textColor === "purple",
    [s.darkpurple]: textColor === "darkpurple",
    [s.lightblue]: textColor === "lightblue",
    [s.orange]: textColor === "orange",
    [s.lightorange]: textColor === "lightorange",
    [s.grey]: textColor === "grey",
    [s.white]: textColor === "white",
    [s.rvYellow]: textColor === "rvYellow",
    [s.rvOrange]: textColor === "rvOrange",
    [s.rvGrey100]: textColor === "rvGrey100",
    [s.rvGrey200]: textColor === "rvGrey200",
    [s.rvGrey300]: textColor === "rvGrey300",
    [s.rvGrey400]: textColor === "rvGrey400",
    [s.rvGrey500]: textColor === "rvGrey500"
  };
};

export default useTextColor;
